exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}#app,body{width:100%;margin:0}li,ol,ul{list-style:none;margin:0;padding:0}::-webkit-scrollbar{display:none}.container{position:relative}a{text-decoration:none}.fontDown1{font-family:NanumBarunGothicUltraLightOTF}.fontDown1,.fontDown2{cursor:default;position:absolute;color:#fff;font-size:20px}.fontDown2{font-family:NanumBarunGothicOTF}.fontDown3{font-family:NanumBarunGothicLightOTF}.fontDown3,.fontDown4{cursor:default;position:absolute;color:#fff;font-size:20px}.fontDown4{font-family:NanumBarunGothicBoldOTF}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05b38be6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 335
// module chunks = 0